import React, {lazy, Suspense, useEffect, useMemo, useState} from 'react';
import {Box, Dialog, DialogContent, DialogTitle, IconButton} from 'web-library';
import {useTheme} from '@mui/material/styles';

import {makeStyles} from 'tss-react/mui';
import {useTranslation} from 'react-i18next';
import {IconName} from 'web-library/stories/atom/Icon/Icon';
import {AnnouncementDetail} from 'web-library/models/Announcements';
import AnnouncementSingleContent from './AnnouncementSingleContent';
import {AnnouncementMessageModel} from 'web-library/stories/molecule/Announcement/Announcement';
import {useGetAnnouncementNoticeDetails} from '../../../api-refactored/announcements/useGetAnnouncementNoticeDetails';
import {usePostSearchAnnouncements} from "../../../api-refactored/announcements/usePostSearchAnnouncements";

const Announcement = lazy(() => import('web-library/stories/molecule/Announcement/Announcement'));

const useStyles = makeStyles()((theme) =>
    ({
      announcementTitleContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2.5),
      },
      divider: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(-2),
      },
    }));

const AdvisoryBannerContent = () => {
  const {classes} = useStyles();
  const {t} = useTranslation();
  const theme = useTheme();

  const [openAnnouncementModal, setOpenAnnouncementModal] = useState<boolean>(false);
  const [announcement, setAnnouncement] = useState<AnnouncementDetail[]>([]);
  const [announcementNoticeDetails, setAnnouncementNoticeDetails] = useState<AnnouncementDetail>();

  const {mutate: postSearchAnnouncements} = usePostSearchAnnouncements({
    onSuccess: (data) => {
      setAnnouncement(data.content);
    },
    isRedirect: false,
  });

  const {data: announcementNoticeDetailForModal} = useGetAnnouncementNoticeDetails({
    announcementType: "ADVISORY_BANNER",
    announcementUuid: announcementNoticeDetails?.uuid || '',
    enabled: !!announcementNoticeDetails?.uuid,
  });

  const openBroadcastModal = (index: number) => {
    setAnnouncementNoticeDetails(announcement[index]);
    setOpenAnnouncementModal(true);
  };

  const transformAnnouncements = useMemo<AnnouncementMessageModel[]>(() => {
    return announcement.map((m) => ({
      message: m.title,
      showReadMore: !!m.description,
    }));
  }, [announcement]);

  const onAnnouncements = () => {
    setAnnouncement([]);
  };

  useEffect(() => {
      postSearchAnnouncements({
        q: '',
        announcementType: "ADVISORY_BANNER",
        apiPathParam: {},
      });
  }, []);

  const handleCloseAnnouncementModal = () => {
    setOpenAnnouncementModal(false);
  };

  return (
      <>
        {announcement.length > 0 && (
            <Suspense fallback={null}>
              <Announcement
                  messages={transformAnnouncements}
                  onClose={onAnnouncements}
                  onClickReadMore={openBroadcastModal}
                  dismissible={false}
              />
            </Suspense>
        )}
        {announcementNoticeDetailForModal && (
            <Suspense fallback={null}>
              <Dialog open={openAnnouncementModal} maxWidth="lg">
                <DialogTitle>
                  <Box className={classes.announcementTitleContainer}>
                    {t('announcementsNotifications->>AnnouncementNoticeBoard.Notice')}
                    <Box>
                      <IconButton
                          id="button-announcement-content-close"
                          name={IconName.cross}
                          iconSize="S"
                          color={theme.color.icon.iconDefault}
                          ariaLabel="announcement-content-close"
                          onClick={handleCloseAnnouncementModal}
                      />
                    </Box>
                  </Box>
                </DialogTitle>
                <DialogContent>
                  {announcementNoticeDetailForModal && (
                      <AnnouncementSingleContent
                          announcementNoticeDetails={announcementNoticeDetailForModal}/>
                  )}
                </DialogContent>
              </Dialog>
            </Suspense>
        )}
      </>
  );
};


export default AdvisoryBannerContent;
